export default {
    checkTokenValidity() {
        const token = this.getToken();
        if (!token) return this.redirectToLogin();

        const decodedToken = this.decodeJWT(token);
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp && decodedToken.exp < currentTime) this.redirectToLogin();
    },

    decodeJWT(token) {
        try {
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                    .join("")
            );
            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error("Erreur lors du décodage du token:", error);
            return null;
        }
    },

    getToken() {
        const name = "token=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(";");

        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i].trim();
            if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
        }
        return null;
    },

    redirectToLogin() {
        window.location.href = "/login";
    },

    startTokenExpirationCheck() {
        const currentRoute = window.location.pathname;
        const excludedRoutes = ["/login", "/register"];
        const dynamicRouteRegex = /^\/partages\/[0-9]+$/;

        if (excludedRoutes.includes(currentRoute) || dynamicRouteRegex.test(currentRoute)) return;

        this.checkTokenValidity();

        setInterval(() => {
            this.checkTokenValidity();
        }, 1000);
    },
};
